import React, { PureComponent } from 'react';
import Tabs from 'components/Tabs';
import FieldsMapping from 'containers/settings/deprecatedIntegrationsManagement/components/FieldsMapping';
import Loading from 'components/Loading';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import './style.scss';

class FieldsMappingTabs extends PureComponent {
    state = {};

    constructor(props) {
        super(props);
    }

    render() {
        const { fields, selectFields, fieldsConfig, literals, stepperAlertErrors } = this.props;
        let tabs = Object.keys(fieldsConfig).map((entity, index) => {
            let errorClass =
                stepperAlertErrors[entity] &&
                ((stepperAlertErrors[entity].fm && stepperAlertErrors[entity].fm.errors) ||
                    (stepperAlertErrors[entity].ext && stepperAlertErrors[entity].ext.errors))
                    ? 'react-tabs__tab tab-error'
                    : 'react-tabs__tab';
            return {
                title: entity,
                content: (
                    <FieldsMapping
                        {...this.props}
                        key={entity}
                        fields={fields[entity]}
                        selectFields={selectFields[entity]}
                        fieldsConfig={fieldsConfig[entity]}
                        stepperAlertErrors={stepperAlertErrors[entity] || {}}
                    />
                ),
            };
        });
        if (!fields || !selectFields || !fieldsConfig) return <Loading />;
        return (
            <div className="fields-mapping" id="fields-mapping">
                <div className="fields-mapping-title-description">
                    <div className="fields-mapping-title">
                        <Literal
                            literal={
                                literals['label_integration_match_fields'] ||
                                'label_integration_match_fields'
                            }
                        />
                    </div>
                    <div className="fields-mapping-description">
                        <Literal
                            literal={
                                literals['label_integration_match_fields_description'] ||
                                'label_integration_match_fields_description'
                            }
                        />
                    </div>
                </div>
                <Tabs
                    className="fields-mapping-tabs"
                    content={tabs}
                    onChange={this.handleTabChange}
                />
            </div>
        );
    }
}

export default FieldsMappingTabs;
